module.exports = __webpack_public_path__ + "static/media/mail.e73a6447.svg";